import { render, staticRenderFns } from "./moderatorSubmit.vue?vue&type=template&id=5412a30d&scoped=true"
import script from "./moderatorSubmit.vue?vue&type=script&lang=js"
export * from "./moderatorSubmit.vue?vue&type=script&lang=js"
import style0 from "./moderatorSubmit.vue?vue&type=style&index=0&id=5412a30d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5412a30d",
  null
  
)

export default component.exports